import {useEffect} from 'react';

// Read existing layout only: navigation and checkout styles are not modified.
export function analyticsPosition(win,doc) {
  const viewport=win.visualViewport;
  const height=viewport?.height || win.innerHeight;
  const top=viewport?.offsetTop || 0,bottom=top+height;
  let occupied=0,checkout=false;
  const visible=element=>{
    const rect=element.getBoundingClientRect(),style=win.getComputedStyle(element);
    return rect.height>0&&style.display!=='none'&&style.visibility!=='hidden'?rect:null;
  };
  for(const element of doc.querySelectorAll('.cm-overlay'))if(visible(element))checkout=true;
  for(const element of doc.querySelectorAll('.stir-mobile-nav, .cm-overlay .sticky-cta')) {
    const rect=visible(element);
    if(rect&&rect.top<bottom&&rect.bottom>top)occupied=Math.max(occupied,bottom-rect.top);
  }
  return {bottom:Math.ceil(Math.max(0,win.innerHeight-bottom)+occupied),height:Math.max(0,height-occupied),checkout};
}
export function useAnalyticsPosition(ref) {
  useEffect(()=>{
    const root=ref.current;
    const resize=typeof ResizeObserver==='undefined'?null:new ResizeObserver(update);
    const observed=new Set();
    function update() {
      const layout=analyticsPosition(window,document);
      root.style.setProperty('--analytics-bottom-offset',`${layout.bottom}px`);
      root.style.setProperty('--analytics-available-height',`${layout.height}px`);
      root.dataset.checkoutOverlay=String(layout.checkout);
      for(const element of document.querySelectorAll('.stir-mobile-nav, .cm-overlay .sticky-cta')) {
        if(!observed.has(element)){observed.add(element);resize?.observe(element);}
      }
    }
    const mutations=new MutationObserver(update);
    mutations.observe(document.body,{childList:true,subtree:true,attributes:true,attributeFilter:['class','hidden']});
    window.addEventListener('resize',update);window.addEventListener('scroll',update,true);
    window.visualViewport?.addEventListener('resize',update);window.visualViewport?.addEventListener('scroll',update);
    update();
    return()=>{mutations.disconnect();resize?.disconnect();window.removeEventListener('resize',update);window.removeEventListener('scroll',update,true);
      window.visualViewport?.removeEventListener('resize',update);window.visualViewport?.removeEventListener('scroll',update);};
  },[ref]);
}
